import { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { Icon } from '@iconify/react';
import { useQuery } from "react-query";
import { updateEquipmentUnitInfo } from "../../../api";
import { checkForAPISuccess, showErrorToast, showSuccessToast } from "../../../Common/commonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { SET_ONGOING_EDIT_GLOBALLY, UPDATE_EQUIPMENT_UNIT_FOUNDATION } from "../../../store/actions";
import _ from "lodash";
import { ClipLoader } from "react-spinners";

const EquipmentUnitFoundation = props => {

    const dispatch = useDispatch(), EDIT = "EDIT", CANCEL = "CANCEL";
    const isLockedProfile = useSelector(store => store.equipment.isLockedProfile);
    const isEditOngoing = useSelector(store => store.equipment.isEditOngoing);
    const [utils, setUtils] = useState({ foundation: props.foundation, isEditActive: false, id: props.id });
    const useQueryConfiguration = {
        enabled: false, retry: false, retryOnMount: false,
        refetchOnMount: false, refetchOnWindowFocus: false
    }

    const updateFoundation = async () => {
        const response = await updateEquipmentUnitInfo(props.id, { foundation: utils.foundation });
        return response?.data;
    }

    const updateFoundationQuery = useQuery(`update-equipment-unit-foundation-${props.id}`, updateFoundation, { ...useQueryConfiguration });

    const handleFoundationEdit = (action) => {
        setUtils({
            foundation: _.isEqual(action, EDIT) ? utils.foundation : props.foundation,
            isEditActive: _.isEqual(action, EDIT)
        });
        dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: _.isEqual(action, EDIT) });
    }

    const returnIcons = (icon, className, callBack) =>
        <Icon onClick={() => callBack()} className={className} icon={icon} width={20} height={20} />

    useEffect(() => {
        if(updateFoundationQuery.isFetched) {
            if(updateFoundationQuery.isSuccess && checkForAPISuccess(updateFoundationQuery?.data?.statusCode)) {
                showSuccessToast("Foundation updated successfully");
                dispatch({ type: UPDATE_EQUIPMENT_UNIT_FOUNDATION, payload: { name: props.name, foundation: utils.foundation } });
            }
            else {
                showErrorToast("Failed to update foundation");
            }
            updateFoundationQuery.remove();
        }
    }, [updateFoundationQuery.isFetched]);

    useEffect(() => {
        setUtils({ isEditActive: false, foundation: props.foundation });
        dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: false });
    }, [props.foundation]);

    return (
        <div className="border-bottom-secondary">
            {
                updateFoundationQuery.isFetching ?
                    <Col md={{ span: 12 }} className='equipment-unit-field-loader my-1'>
                        <ClipLoader color='#075978' size={25} />
                    </Col>
                        :
                    <div className='equipment-unit-field-container py-1'>
                        <div className='ml-2 w-50'>
                            Foundation
                        </div>
                        <div className='mr-2 w-50 justify-end'>
                            {
                                utils.isEditActive ?
                                    <div className='h-100 w-75'>
                                        <div className='justify-end'>
                                            <select
                                                disabled={updateFoundationQuery.isFetching}
                                                className="edit-dropdown text-left"
                                                defaultValue={!_.isEmpty(props?.foundation) ? props.foundation : "default"}
                                                onChange={(e) => setUtils({ ...utils, foundation: e.target.value })}
                                            >
                                                <option disabled value={"default"}>Select</option>
                                                <option>Rigid</option>
                                                <option>Flexible</option>
                                            </select>
                                            {
                                                props.foundation !== utils.foundation &&
                                                    <div>
                                                        {returnIcons("feather-check", "cursor-pointer", () => updateFoundationQuery.refetch())}
                                                    </div>
                                            }
                                            <div>
                                                {returnIcons("feather-x", "cursor-pointer text-color-grey", () => handleFoundationEdit(CANCEL))}
                                            </div>
                                        </div>
                                    </div>
                                        :
                                    <>
                                        <div className={"mr-2"}>
                                            { _.isEmpty(utils.foundation) ? "-" : utils.foundation }
                                        </div>
                                        {
                                            !isLockedProfile &&
                                                returnIcons("feather-edit", isEditOngoing ? "disable-click text-color-grey" : "cursor-pointer", () => handleFoundationEdit(EDIT))
                                        }
                                    </>
                            }
                        </div>
                    </div>
            }
        </div>
    );
}

export default EquipmentUnitFoundation;